import React from "react";
import Carousel from "react-bootstrap/Carousel";
import Button from "react-bootstrap/Button";

function Attractor({ parentEvent }) {
  const handleClick = (event) => {
    event.preventDefault();
    parentEvent();
  };

  return (
    <section className="attractor">
      {/* <img
        src="https://dummyimage.com/1920x878/d9d9d9/d9d9d9&text=Attractor"
        alt=""
      ></img> */}

      <Carousel interval={3500} fade={true} indicators={false} controls={false} pause={false}>
        <Carousel.Item>
          <img
            src="images/recharge-earth-attractor-image-1.jpg"
            alt=""
          ></img>
        </Carousel.Item>
        <Carousel.Item>
          <img
            src="images/recharge-earth-attractor-image-2.jpg"
            alt=""
          ></img>
        </Carousel.Item>
        <Carousel.Item>
          <img
            src="images/recharge-earth-attractor-image-3.jpg"
            alt=""
          ></img>
        </Carousel.Item>
        <Carousel.Item>
          <img
            src="images/recharge-earth-attractor-image-4.jpg"
            alt=""
          ></img>
        </Carousel.Item>
        <Carousel.Item>
          <img
            src="images/recharge-earth-attractor-image-5.jpg"
            alt=""
          ></img>
        </Carousel.Item>
        <Carousel.Item>
          <img
            src="images/recharge-earth-attractor-image-6.jpg"
            alt=""
          ></img>
        </Carousel.Item>
        <Carousel.Item>
          <img
            src="images/recharge-earth-attractor-image-7.jpg"
            alt=""
          ></img>
        </Carousel.Item>
        <Carousel.Item>
          <img
            src="images/recharge-earth-attractor-image-8.jpg"
            alt=""
          ></img>
        </Carousel.Item>
        <Carousel.Item>
          <img
            src="images/recharge-earth-attractor-image-9.jpg"
            alt=""
          ></img>
        </Carousel.Item>
        <Carousel.Item>
          <img
            src="images/recharge-earth-attractor-image-10.jpg"
            alt=""
          ></img>
        </Carousel.Item>
      </Carousel>

      <Button type="button" onClick={handleClick}>
        Tap to start
      </Button>
    </section>
  );
}

export default Attractor;
